// import _ from 'lodash'

class ElementHelper {
  static byClass (className, target, loop) {
    const elems = target.getElementsByClassName(className)
    for (const e in elems) {
      const elem = elems[e]
      if (isNaN(parseInt(e, 10))) {
        continue
      }
      loop(elem, e)
    }
  }

  static byTag (tagName, target, loop) {
    const elems = target.getElementsByTagName(tagName)
    for (const e in elems) {
      const elem = elems[e]
      if (isNaN(parseInt(e, 10))) {
        continue
      }
      loop(elem, e)
    }
  }
}

export default ElementHelper
